import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setCarouselPosition } from './actions'

function mapStateToProps(state, hocProps) {
    return {
        position: state.getIn(['banner', 'carousel', hocProps.id, 'position'], 0),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setCarouselPosition }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
